import { configureStore } from '@reduxjs/toolkit';
import React from 'react';
import { Provider } from 'react-redux';

import rootReducer from './reducers';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }), // TODO: to be removed after refactoring non-serializable objects in redux {Overlay}
});

export const ReduxProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => <Provider store={store}>{children}</Provider>;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

type PersistPagesReducerObj = {
  [key: string]: keyof RootState['pages'];
};

export const persistPagesReducerObj: PersistPagesReducerObj = {
  favorites: 'favorites',
  checkoutDelivery: 'checkoutDelivery',
  serviceBooking: 'serviceBooking',
};
